/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import summaryStyle from "@/src/components/Form/Common/Style/summaryStyle";
import { dayjsToGermanDate } from "@/src/services/formatService";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";

type AlimonyDataProps = {
  formData: AbstractCase | Record<string, any>;
};

const AlimonyData = ({ formData }: AlimonyDataProps) => {
  return (
    <>
      <Grid sx={summaryStyle.subHeadline} size={12}>
        <Typography variant={"h6"}>Familiäre Situation</Typography>
      </Grid>
      {formData.basicChoice === "complete" && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"dateMarriage"} />
            Datum standesamtliche Heirat
          </Grid>
          <Grid size={12}>
            {dayjsToGermanDate(formData.dateMarriage)}
          </Grid>
        </>
      )}
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"areSeparated"} />
        Sind Sie getrennt?
      </Grid>
      <Grid size={12}>
        {formData.areSeparated == "yes" ? "Ja" : "Nein"}
      </Grid>
      {formData.areSeparated === "yes" && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"dateSeparation"} />
            Datum der Trennung
          </Grid>
          <Grid size={12}>
            {dayjsToGermanDate(formData.dateSeparation)}
          </Grid>
        </>
      )}
      {formData.basicChoice === "complete" && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"areDivorced"} />
            Sind Sie geschieden?
          </Grid>
          <Grid size={12}>
            {formData.areDivorced === "yes" ? "Ja" : "Nein"}
          </Grid>

          {formData.areDivorced === "yes" && (
            <>
              <Grid sx={summaryStyle.question} size={12}>
                <Box id={"dateDivorce"} />
                Datum der Scheidung
              </Grid>
              <Grid size={12}>
                {dayjsToGermanDate(formData.dateDivorce)}
              </Grid>
            </>
          )}
        </>
      )}
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"numberOfChildren"} />
        Anzahl aller Kinder
      </Grid>
      <Grid size={12}>
        {formData.numberOfChildren}
      </Grid>
    </>
  );
};

export default AlimonyData;
